import achieve1 from "@/../../hypetrain/static/img/for-business/achieve1-1.png";
import achieve3 from "@/../../hypetrain/static/img/for-business/achieve1-3.png";
import achieve4 from "@/../../hypetrain/static/img/for-business/achieve1-4.png";
import achieve5 from "@/../../hypetrain/static/img/for-business/achieve1-5.png";
import leadership from "@/../../hypetrain/static/img/leadership.png";
import { SITE_NAME } from "@/css/constants";
import { MarketingPageBenefits, MarketingPageConfig } from "@/types/marketing";

import { CTAMini } from "./CTAMini";

const options: MarketingPageConfig = {
  page: "B2B_LEADERSHIP",
  color: "#EA9924",
  metaTitle: `Leadership Coaching Programs for Business - ${SITE_NAME}`,
  metaDescription: `Deploy leadership coaching into your organization. Grow your first-time managers and hone your long-standing executives. Try ${SITE_NAME} today.`,
  metaImage:
    "https://placement-pub.s3.us-east-2.amazonaws.com/leadership-meta.png",
  defaultHeadline: "Invest In Your Leaders",
  defaultSubHeader:
    "Grow your first-time managers and develop your leaders with 1:1 coaching",
  benefitsHeadline: "Get set up in no time",
  ctaText: "Grow faster with a coach",
  pricingIntro: "",
  audience: "B2B",
  serviceType: "session",
  specialtySlug: "leadership-coaching",
  FAQCategory: "Basics",
  marketingVideoId: 673995906,
  background: "linear-gradient(-25deg,#38ced1 30%,#2474e7 76%)",
  brandBg: "#123568",
  heroGraphic: leadership,
  heroGraphicWidth: "100%",
  playDark: true,
  pricingCTA: <CTAMini />,
  upsell: true,
  ctaLink: "/demo",
  ctaButtonText: "Talk to Sales",
  useCases: [
    "team-building",
    "virtual-leadership",
    "feedback",
    "grow-manager",
    "exec-presence",
    "imposter-syndrome",
    "manage-up",
    "conflict",
  ],
};

const benefits: MarketingPageBenefits = {
  title: "Grow Your Leaders",
  subtitle: "Personalized development and support for your most visible people",
  items: [
    {
      title: "Accelerate Their Success",
      description: (
        <>
          Help new leaders grow in their role. Choose coaches that reinforce
          your corporate culture.
        </>
      ),
      photo: achieve1,
      bgColor: "#FEF0ED",
    },
    {
      title: "Retain Top People",
      description: (
        <>
          Keep great leaders engaged and prevent attrition caused by poor
          management.
        </>
      ),
      photo: achieve4,
      bgColor: "#EBF3FD",
    },
    {
      title: "Develop Key Skills",
      description: (
        <>
          Core leadership skills aren’t learned in a single training. Coaching
          reinforces concepts over time.
        </>
      ),
      photo: achieve5,
      bgColor: "#FDF7E9",
    },
    {
      title: "World-Leading Expertise",
      description: (
        <>
          Your leaders will solve challenges by partnering with a coach who has
          been in their shoes.
        </>
      ),
      photo: achieve3,
      bgColor: "#E9F7EF",
    },
  ],
};

export default {
  options,
  benefits,
};
